"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Align", {
  enumerable: true,
  get: function get() {
    return _Align["default"];
  }
});
Object.defineProperty(exports, "ColorsPainting", {
  enumerable: true,
  get: function get() {
    return _ColorsPainting["default"];
  }
});
Object.defineProperty(exports, "CropsArtboards", {
  enumerable: true,
  get: function get() {
    return _CropsArtboards["default"];
  }
});
Object.defineProperty(exports, "DesignFiles", {
  enumerable: true,
  get: function get() {
    return _DesignFiles["default"];
  }
});
Object.defineProperty(exports, "DesignProcess", {
  enumerable: true,
  get: function get() {
    return _DesignProcess["default"];
  }
});
Object.defineProperty(exports, "DesignTools", {
  enumerable: true,
  get: function get() {
    return _DesignTools["default"];
  }
});
Object.defineProperty(exports, "Flip", {
  enumerable: true,
  get: function get() {
    return _Flip["default"];
  }
});
Object.defineProperty(exports, "GraphicTablets", {
  enumerable: true,
  get: function get() {
    return _GraphicTablets["default"];
  }
});
Object.defineProperty(exports, "GridsRulers", {
  enumerable: true,
  get: function get() {
    return _GridsRulers["default"];
  }
});
Object.defineProperty(exports, "Layers", {
  enumerable: true,
  get: function get() {
    return _Layers["default"];
  }
});
Object.defineProperty(exports, "Pathfinder", {
  enumerable: true,
  get: function get() {
    return _Pathfinder["default"];
  }
});
Object.defineProperty(exports, "Reorder", {
  enumerable: true,
  get: function get() {
    return _Reorder["default"];
  }
});
Object.defineProperty(exports, "Resize", {
  enumerable: true,
  get: function get() {
    return _Resize["default"];
  }
});
Object.defineProperty(exports, "Rotate", {
  enumerable: true,
  get: function get() {
    return _Rotate["default"];
  }
});
Object.defineProperty(exports, "Shapes", {
  enumerable: true,
  get: function get() {
    return _Shapes["default"];
  }
});
Object.defineProperty(exports, "Transform", {
  enumerable: true,
  get: function get() {
    return _Transform["default"];
  }
});
Object.defineProperty(exports, "Vectors", {
  enumerable: true,
  get: function get() {
    return _Vectors["default"];
  }
});
Object.defineProperty(exports, "index", {
  enumerable: true,
  get: function get() {
    return _index["default"];
  }
});

var _Align = _interopRequireDefault(require("./Align.js"));

var _ColorsPainting = _interopRequireDefault(require("./ColorsPainting.js"));

var _CropsArtboards = _interopRequireDefault(require("./CropsArtboards.js"));

var _DesignFiles = _interopRequireDefault(require("./DesignFiles.js"));

var _DesignProcess = _interopRequireDefault(require("./DesignProcess.js"));

var _DesignTools = _interopRequireDefault(require("./DesignTools.js"));

var _Flip = _interopRequireDefault(require("./Flip.js"));

var _GraphicTablets = _interopRequireDefault(require("./GraphicTablets.js"));

var _GridsRulers = _interopRequireDefault(require("./GridsRulers.js"));

var _Layers = _interopRequireDefault(require("./Layers.js"));

var _Pathfinder = _interopRequireDefault(require("./Pathfinder.js"));

var _Reorder = _interopRequireDefault(require("./Reorder.js"));

var _Resize = _interopRequireDefault(require("./Resize.js"));

var _Rotate = _interopRequireDefault(require("./Rotate.js"));

var _Shapes = _interopRequireDefault(require("./Shapes.js"));

var _Transform = _interopRequireDefault(require("./Transform.js"));

var _Vectors = _interopRequireDefault(require("./Vectors.js"));

var _index = _interopRequireDefault(require("./index.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }